// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.addsurveycycledialog_featuredItem__dte2j {
    flex: 1 1;
    margin: 0px 20px;
    padding: 30px;
    border-radius: 10px;
    box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.75);
}

.addsurveycycledialog_dialogInputs__Jvcia {
    width: 100%;
}

.addsurveycycledialog_featuredTitleHeader__-guup {
    color: var(--hsrcDarkBlue);
    font-size: 16px;
    font-weight: bold;
}

.addsurveycycledialog_formControl__Ny7TS {
    width: 100%;
}

.addsurveycycledialog_sectorLabel__c6B-o {
    margin: 0 !important;
    font-size: 0.9rem;
}

.addsurveycycledialog_sectorLabel__c6B-o .MuiCheckbox-root {
    padding: 4px !important;
}

`, "",{"version":3,"sources":["webpack://./src/pages/ResearcherDashboard/components/SystemAdministration/AddSurveyCycleDialog/addsurveycycledialog.module.css"],"names":[],"mappings":"AAAA;IACI,SAAO;IACP,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IAEnB,kDAAkD;AACtD;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;AAC3B","sourcesContent":[".featuredItem {\r\n    flex: 1;\r\n    margin: 0px 20px;\r\n    padding: 30px;\r\n    border-radius: 10px;\r\n    -webkit-box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.75);\r\n    box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.75);\r\n}\r\n\r\n.dialogInputs {\r\n    width: 100%;\r\n}\r\n\r\n.featuredTitleHeader {\r\n    color: var(--hsrcDarkBlue);\r\n    font-size: 16px;\r\n    font-weight: bold;\r\n}\r\n\r\n.formControl {\r\n    width: 100%;\r\n}\r\n\r\n.sectorLabel {\r\n    margin: 0 !important;\r\n    font-size: 0.9rem;\r\n}\r\n\r\n.sectorLabel :global(.MuiCheckbox-root) {\r\n    padding: 4px !important;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"featuredItem": `addsurveycycledialog_featuredItem__dte2j`,
	"dialogInputs": `addsurveycycledialog_dialogInputs__Jvcia`,
	"featuredTitleHeader": `addsurveycycledialog_featuredTitleHeader__-guup`,
	"formControl": `addsurveycycledialog_formControl__Ny7TS`,
	"sectorLabel": `addsurveycycledialog_sectorLabel__c6B-o`
};
export default ___CSS_LOADER_EXPORT___;
